module.exports = __webpack_public_path__ + "static/media/random-circles.32a89b0a.PNG";